import image1 from "./Bambi.png";
import image2 from "./Onur.png";
import image3 from "./amazon.png";
import image4 from "./aselsan-3.png";
import image5 from "./aspilsan.png";
import image6 from "./avva-2.png";
import image7 from "./boyner-2.png";
import image8 from "./cetinmkaya.png";
import image9 from "./civil.png";
import image10 from "./coil.png";
import image11 from "./dagi.png";
import image12 from "./damat.png";
import image13 from "./desa.png";
import image14 from "./dogus.png";
import image15 from "./ebebek.png";
import image16 from "./eec-1.png";
import image17 from "./emniyet.png";
import image18 from "./english-home.png";
import image19 from "./greyder.png";
import image20 from "./hepsiburada.png";
import image21 from "./hummel.png";
import image22 from "./iga.png";
import image23 from "./karaca.png";
import image24 from "./kirmizi-kedi.png";
import image26 from "./kom.png";

export const Referances = [
  image1,
  image2,
  image3,
  image4,
  image5,
  image6,
  image7,
  image8,
  image9,
  image10,
  image11,
  image12,
  image13,
  image14,
  image15,
  image16,
  image17,
  image18,
  image19,
  image20,
  image21,
  image22,
  image23,
  image24,
  image26,
];
